import React from "react";
import { convertThenFormat, formatDateTime } from "../common-data/Converts";
import { formatWTFString } from "../common-data/Conversions";
import { getStatusLabel } from "./ExpenseRequestLists";
import "../../styles/expense/PettyCashMobile.css";

const PettyCashMobile = ({
  tableData,
  tablePagination,
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  userInfoData,
  setModValues,
}) => {
  const handlePrintImage = (requestedImg) => {
    if (requestedImg) {
      const printWindow = window.open("", "_blank");
      const printContent = `
        <html>
          <head>
            <title>Print Bill</title>
            <style>
              body {
                display: flex;
                justify-content: center;
                align-items: center;
                margin: 0;
                padding: 20px;
              }
              img {
                max-width: 100%;
                height: auto;
              }
            </style>
          </head>
          <body>
            <img src="${requestedImg}" alt="Bill Image" />
          </body>
        </html>
      `;
      printWindow.document.write(printContent);
      printWindow.document.close();
      printWindow.onload = () => {
        printWindow.print();
        printWindow.onafterprint = () => {
          printWindow.close();
        };
      };
    }
  };

  const getStatusIcon = (status) => {
    const planStatus = status?.replace(/ /g, "_")?.toLowerCase();

    switch (planStatus) {
      case "approved_paid":
        return (
          <div className="status-icon approved">
            <svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
              <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
            </svg>
          </div>
        );
      case "approved_notpaid":
        return (
          <div className="status-icon approved-pending">
            <svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
              <path d="M8 1a7 7 0 1 0 4.95 11.95l.707.707A8.001 8.001 0 1 1 8 0z" />
              <path d="M7.5 3a.5.5 0 0 1 .5.5v5.21l3.248 1.856a.5.5 0 0 1-.496.868l-3.5-2A.5.5 0 0 1 7 9V3.5a.5.5 0 0 1 .5-.5" />
            </svg>
          </div>
        );
      case "pending":
        return (
          <div className="status-icon pending">
            <svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
              <path d="M7.5 3a.5.5 0 0 1 .5.5v4.25l.5.5L12 8l-3.5-3.5V3.5a.5.5 0 0 1 .5-.5" />
            </svg>
          </div>
        );
      default:
        return (
          <div className="status-icon rejected">
            <svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
              <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z" />
            </svg>
          </div>
        );
    }
  };

  const renderPagination = () => {
    if (!tablePagination || tablePagination.length === 0) return null;

    return (
      <div className="pagination-container">
        <div className="pagination-info">
          Page {isPage} of {tablePagination.length}
        </div>
        <div className="pagination-controls">
          <button
            className={`pagination-btn ${isPage <= 1 ? "disabled" : "enabled"}`}
            disabled={isPage <= 1}
            onClick={() => setIsPage(isPage - 1)}
          >
            <svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
              <path
                fillRule="evenodd"
                d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
              />
            </svg>
          </button>
          <button
            className={`pagination-btn ${
              isPage >= tablePagination.length ? "disabled" : "enabled"
            }`}
            disabled={isPage >= tablePagination.length}
            onClick={() => setIsPage(isPage + 1)}
          >
            <svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
              <path
                fillRule="evenodd"
                d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
              />
            </svg>
          </button>
        </div>
      </div>
    );
  };

  return (
    <div className="petty-cash-mobile-wrapper">
      {!tableData || tableData.length === 0 ? (
        <div className="empty-state">
          <svg width="64" height="64" fill="currentColor" viewBox="0 0 16 16">
            <path d="M1 3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1H1ZM2 4v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V4H2Zm3.5 1a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-1 0v-8a.5.5 0 0 1 .5-.5Zm3 0a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-1 0v-8a.5.5 0 0 1 .5-.5Zm3 0a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-1 0v-8a.5.5 0 0 1 .5-.5Z" />
          </svg>
          <h3>No Petty Cash Requests</h3>
          <p>No petty cash requests found for the current filters.</p>
        </div>
      ) : (
        <>
          {tableData.map((row, index) => {
            const planStatus = row?.status?.replace(/ /g, "_")?.toLowerCase();
            const isSameAccount =
              (userInfoData?.uid || userInfoData?.user_id) ===
              row?.requested_by;
            const isEditDisable = !isSameAccount || planStatus !== "pending";
            const isClusterManager =
              userInfoData?.account_type === "cluster_manager";

            return (
              <div key={index} className="petty-cash-card">
                {/* Header with Status and Amount */}
                <div className="card-header">
                  <div className="status-icon-container">
                    {getStatusIcon(row?.status)}
                    <div>
                      <div className="status-text">
                        {getStatusLabel(row?.status || "-")}
                      </div>
                      <div className="expense-type-badge">
                        {formatWTFString(row?.expense_type || "")}
                      </div>
                    </div>
                  </div>
                  <div className="amount-section">
                    <div className="amount-display">
                      ₹{convertThenFormat(row?.requested_amount || 0)}
                    </div>
                    {row?.gym_name && (
                      <small className="gym-name">{row.gym_name}</small>
                    )}
                  </div>
                </div>

                {/* Details Section */}
                <div className="details-section">
                  <div className="detail-row">
                    <div className="detail-label">Requested By</div>
                    <div className="detail-value">
                      <strong>{row?.requested_by_name || "NA"}</strong>
                      <small>
                        {row?.requested_by_email && (
                          <div>{row.requested_by_email}</div>
                        )}
                        {row?.requested_by_mobile && (
                          <div>{row.requested_by_mobile}</div>
                        )}
                      </small>
                    </div>
                  </div>

                  <div className="detail-row">
                    <div className="detail-label">Approval Manager</div>
                    <div className="detail-value">
                      <strong>{row?.approval_manager_name || "NA"}</strong>
                      <small>
                        {row?.approval_manager_email && (
                          <div>{row.approval_manager_email}</div>
                        )}
                        {row?.approval_manager_mobile && (
                          <div>{row.approval_manager_mobile}</div>
                        )}
                      </small>
                    </div>
                  </div>

                  <div className="detail-row">
                    <div className="detail-label">Payment Method</div>
                    <div className="detail-value">
                      <strong>{row?.payment_method || "NA"}</strong>
                      {row?.payment_method === "bank" && (
                        <small>
                          <div>Account: {row?.account_number || ""}</div>
                          <div>IFSC: {row?.ifsc_code || ""}</div>
                        </small>
                      )}
                      {row?.payment_method === "upi" && (
                        <small>
                          <div>{row?.upi_id || ""}</div>
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="detail-row">
                    <div className="detail-label">Date Added</div>
                    <div className="detail-value">
                      {row?.date_added ? formatDateTime(row.date_added) : "-"}
                    </div>
                  </div>
                </div>

                {/* Action Buttons */}
                <div className="action-buttons">
                  <button
                    className="action-btn primary"
                    onClick={() => {
                      setModValues((prevs) => ({
                        ...prevs,
                        isModOpen: true,
                        cardName: "view_details",
                        rowData: row,
                      }));
                    }}
                  >
                    <svg
                      width="16"
                      height="16"
                      fill="currentColor"
                      viewBox="0 0 16 16"
                    >
                      <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0" />
                      <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8m8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
                    </svg>
                    View Details
                  </button>

                  <button
                    className={`action-btn secondary ${
                      row?.requested_img ? "enabled" : "disabled"
                    }`}
                    onClick={() => handlePrintImage(row?.requested_img)}
                    disabled={!row?.requested_img}
                  >
                    <svg
                      width="16"
                      height="16"
                      fill="currentColor"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8 2a5.53 5.53 0 0 0-3.594 1.342c-.766.66-1.321 1.52-1.464 2.383C1.266 6.095 0 7.555 0 9.318 0 11.366 1.708 13 3.781 13h8.906C14.502 13 16 11.57 16 9.773c0-1.636-1.242-2.969-2.834-3.194C12.923 3.999 10.69 2 8 2m2.354 6.854-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 1 1 .708-.708L7.5 9.293V5.5a.5.5 0 0 1 1 0v3.793l1.146-1.147a.5.5 0 0 1 .708.708" />
                    </svg>
                    Print Bill
                  </button>

                  {isClusterManager && isSameAccount && (
                    <button
                      className={`action-btn danger ${
                        isEditDisable ? "disabled" : ""
                      }`}
                      disabled={isEditDisable}
                      onClick={() =>
                        setModValues((prevs) => ({
                          ...prevs,
                          isModOpen: true,
                          cardName: "edit",
                          rowData: row,
                        }))
                      }
                    >
                      <svg
                        width="16"
                        height="16"
                        fill="currentColor"
                        viewBox="0 0 16 16"
                      >
                        <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z" />
                      </svg>
                      Edit
                    </button>
                  )}
                </div>
              </div>
            );
          })}

          {renderPagination()}
        </>
      )}
    </div>
  );
};

export default PettyCashMobile;
